import { createContext, useContext } from 'react';
import { BasicTheme } from '@app/domain/theme';

export enum GuestAuthMethodType {
  EmailPassword = 'EmailPassword',
  SSO = 'sso',
  PhoneNumber = 'PhoneNumber',
}

// The AR ("Verify") portal's i18n namespace; also the default so AR keeps its current keys unchanged.
export const DEFAULT_GUEST_LOGIN_I18N_NAMESPACE = 'ar.guestLogin';

const GuestLoginI18nNamespaceContext = createContext<string>(DEFAULT_GUEST_LOGIN_I18N_NAMESPACE);

export const GuestLoginI18nNamespaceProvider = GuestLoginI18nNamespaceContext.Provider;

export function useGuestLoginI18nNamespace(): string {
  return useContext(GuestLoginI18nNamespaceContext);
}

// Minimal shape guestLogin screens need from a host mode's per-org/customer configuration.
export interface GuestLoginConfiguration {
  clientName?: string;
}

// Minimal theme shape guestLogin screens need from a host mode's branded theme.
export interface GuestLoginBrandedTheme extends BasicTheme {
  isHeaderDark: boolean;
  brand?: {
    logo?: ResourceData;
    clientName?: string;
    additionalLogos?: ResourceData[];
  };
}

export enum GuestAuthCodeDeliveryMethod {
  TextMessage = 'TextMessage',
  PhoneCall = 'PhoneCall',
}

export const authMethodTypeOrder = Object.values(GuestAuthMethodType);

export interface GuestLoginCredentials {
  phoneToken?: string;
  emailToken?: string;
  ssoToken?: string;
}

export interface RequestWithKnoxId {
  knoxerId: string;
}

export interface CodeRequest extends RequestWithKnoxId {
  id: string;
}

export interface CodeResponse {
  flowId: string;
  codeTTLMinutes: number;
  codeLength: number;
}

export interface TokenRequest extends RequestWithKnoxId {
  flowId: string;
  code: string;
  id: string;
}

export interface TokenResponse {
  expiration: number;
  refreshToken: string | null;
  refreshExpiration: number;
  idToken: string | null;
  tokenType: string;
  otherClaims: any;
  scope: string;
}

export enum GuestLoginStep {
  Welcome,
  Email,
  Phone,
  Account,
  AfterValidation,
}
